// https://github.com/js-cookie/js-cookie
import cookie from 'js-cookie';

const LAST_URL = 'ibtoc-last-url';

export function saveContentURL(url) {
  if (_.isNil(url)) {
    return;
  }
  cookie.set(LAST_URL, url);
}

export function loadContentURL() {
  return cookie.get(LAST_URL);
}
